import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSolution() {
  const problems = ['Inflamación que aparece sin aviso justo antes de una reunión', 'Ropa que aprieta y marca aunque tu peso no cambió', 'Abdomen duro, tenso y doloroso al final del día', "Sensación constante de 'nunca estoy cómoda'"];
  const fears = ['¿Y si esto es para siempre?', '¿Y si mi cuerpo ya no responde?', '¿Y si el problema soy yo?'];
  return <Section background="white" className="relative" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <div className="text-center mb-12" data-id="element-172">
          <span className="text-[#14B8A6] font-bold tracking-wider text-sm uppercase" data-id="element-173">
            El Problema Invisible
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3B32] mt-3 mb-6" data-id="element-174">
            ¿Te sientes identificada con esto?
          </h2>
          <p className="text-lg text-[#5D5D5D]" data-id="element-175">
            Trabajas duro, cumples con todo, pero tu cuerpo parece estar en tu
            contra.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-176">
          <motion.div whileHover={{
          y: -5
        }} className="bg-[#F0FDFA] p-8 rounded-2xl border border-[#5EEAD4]/20" data-id="element-177">
            <div className="flex items-center mb-6" data-id="element-178">
              <div className="bg-[#14B8A6]/10 p-3 rounded-full mr-4" data-id="element-179">
                <AlertCircle className="text-[#14B8A6] w-6 h-6" data-id="element-180" />
              </div>
              <h3 className="text-xl font-serif font-bold text-[#4A3B32]" data-id="element-181">
                Frustraciones Diarias
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-182">
              {problems.map((item, i) => <li key={i} className="flex items-start text-[#5D5D5D]" data-id="element-183">
                  <XCircle className="text-red-400 w-5 h-5 mr-3 mt-0.5 flex-shrink-0" data-id="element-184" />
                  <span data-id="element-185">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="bg-[#F0FDFA] p-8 rounded-2xl border border-[#5EEAD4]/20" data-id="element-186">
            <div className="flex items-center mb-6" data-id="element-187">
              <div className="bg-[#14B8A6]/10 p-3 rounded-full mr-4" data-id="element-188">
                <AlertCircle className="text-[#14B8A6] w-6 h-6" data-id="element-189" />
              </div>
              <h3 className="text-xl font-serif font-bold text-[#4A3B32]" data-id="element-190">
                Miedos Silenciosos
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-191">
              {fears.map((item, i) => <li key={i} className="flex items-start text-[#5D5D5D]" data-id="element-192">
                  <XCircle className="text-red-400 w-5 h-5 mr-3 mt-0.5 flex-shrink-0" data-id="element-193" />
                  <span className="italic" data-id="element-194">"{item}"</span>
                </li>)}
              <li className="flex items-start text-[#5D5D5D]" data-id="element-195">
                <XCircle className="text-red-400 w-5 h-5 mr-3 mt-0.5 flex-shrink-0" data-id="element-196" />
                <span data-id="element-197">Miedo a comer fuera por cómo te sentirás después</span>
              </li>
            </ul>
          </motion.div>
        </div>

        <div className="bg-[#4A3B32] text-white p-8 md:p-12 rounded-3xl text-center relative overflow-hidden" data-id="element-198">
          <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-199"></div>
          <div className="relative z-10" data-id="element-200">
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-4" data-id="element-201">
              No es tu culpa. Y tiene solución.
            </h3>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-8" data-id="element-202">
              La hinchazón no es "normal" ni algo con lo que debas vivir para
              siempre. Es una señal de tu cuerpo pidiendo un cambio simple, no
              una dieta extrema.
            </p>
            <button onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} className="inline-block bg-[#14B8A6] text-white px-6 py-2 rounded-full font-medium text-sm tracking-wide hover:bg-[#0D9488] transition-colors cursor-pointer" data-id="element-203">
              HAY UNA MEJOR MANERA
            </button>
          </div>
        </div>
      </div>
    </Section>;
}